const attentive_trigger = (email)=> {
    if (history.pushState) {
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?discount=LOVELP20';
      window.history.pushState({path:newurl},'',newurl);
    }
    if(window.innerWidth >= 760){
     
        window.__attentive.trigger(
          null,
          null,
          null,
          "1019640"
        );
      } else {
        window.__attentive.trigger(
          null,
          null,
          null,
          "1019118")
      }
  }

document.addEventListener('DOMContentLoaded', () => {
    const attentiveCTAButtons = document.querySelectorAll(".attentive-subscribe-cta")
    attentiveCTAButtons.forEach(attentiveCTAButton => {
        attentiveCTAButton.addEventListener("click", event => {
            event.preventDefault();
            setTimeout(event => {
                attentive_trigger(document.querySelector("#email"))
            }, 100)
            event.stopPropagation();
        })
    })
})
